module.exports = __webpack_public_path__ + "static/media/people-blue-icon.92d29b43.svg";